import React from "react";
import { Nav } from "../../../../layouts/navbar/nav";
import images from "../../../../constant/images";
import {
  PiFacebookLogoLight,
  PiGoogleLogo,
  PiTwitterLogo,
} from "react-icons/pi";
import Header from "../../../../layouts/header";

export const Vision = () => {
  return (
    <>
      <div className="flex flex-col gap-[2rem]  mb-[5rem]">
        {/* <div
          style={{
            backgroundImage: `url(${images.Industry})`,
            height: "60vh",
            backgroundPosition: "40%",
            backgroundRepeat: "no-repeat",
            marginBottom: "0/5rem",
            backgroundSize: "cover",
            position: "relative",
          }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-25"></div>
          <div>
            <Nav />
          </div>
          <div className="h-[50%] flex items-center justify-center">
            <h1 className="text-center relative text-white text-6xl mt-[3.5rem] custom-font">
              Non classé
            </h1>
          </div>
          <svg
            className="absolute bottom-[-9%] left-0 "
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1440 320"
          >
            <path
              class="white"
              fill="#fff"
              fill-opacity="1"
              d="M0,224L60,213.3C120,203,240,181,360,186.7C480,192,600,224,720,245.3C840,267,960,277,1080,250.7C1200,224,1300,170,1380,140L1440,120L1440,320L1380,320C1300,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
            ></path>
          </svg>
        </div> */}
        <Header image={images.Industry} title={"GTM GOLF BLOG"} />
      </div>

      <div className="px-4 sm:px-8 md:px-12 lg:ps-[12rem] lg:pe-[8rem] mb-[8rem]">
        <div className="flex flex-col md:flex-row gap-3">
          <div className="flex flex-col gap-2">
            <p className="flex flex-col ps-[13px] pe-[13px] pt-[5px] pb-[5px] items-center bg-[#45ac4d] text-white font-bold text-[20px]">
              16 <span className="text-[14px] font-[500]">sep</span>
            </p>
            <div>
              <div className="ps-[13px] pe-[13px] pt-[15px] pb-[15px] text-3xl text-[#4c67a2] border-2">
                <PiFacebookLogoLight />
              </div>
              <div className="ps-[13px] pe-[13px] pt-[15px] pb-[15px] text-3xl text-[#00acee] border-2">
                <PiTwitterLogo />
              </div>
              <div className="ps-[13px] pe-[13px] pt-[15px] pb-[15px] text-3xl text-[#d77066] border-2">
                <PiGoogleLogo />
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-[2rem]">
            <p className="text-2xl sm:text-3xl md:text-4xl custom-font">
              The vision of development of golf in Morocco
            </p>
            <p className="text-[#888686] text-[19px] font-[500] w-full md:w-[75vw]">
              The vision of development of golf in Morocco, launched in 2019
              under the aegis of His Royal Highness Prince Moulay Rachid,
              President of the Royal Moroccan Golf Federation, is the result of
              an intensive reflection of exchange and consultation between the
              Federation and the various stakeholders of golf in the Kingdom.
              <br />
              <br />
              This new vision is articulated around two structuring axes: the
              sportsman and the economic.
              <br />
              <br />
              Through this vision, the support to the golf economy aims in
              priority to improve the management of golf courses and services
              provided to foreign tourists and the promotion of Morocco as a
              golf destination to international players.
              <br />
              <br />
              As an imperative lever for the success of this development
              project, training in professions related to golf operation will
              contribute to raising the level of the Moroccan golf product.
              <br />
              <br />
              At the sports level, the Federation aims to broaden the base of
              practitioners and to train national champions in this discipline,
              able to access major circuits and a better world ranking.
              <br />
              <br />
              In order to achieve this objective, the National Technical
              Department has undergone a profound restructuring and is now
              developing a support approach for sports clubs in terms of
              training and coaching on the basis of target contracts.
              <br />
              <br />
              Also, the Federation promotes a local sports and educational
              supervision to strengthen the integration of «young talents»,
              through the establishment of an approved training of coaches who
              participate in this supervision.
              <br />
              <br />
              This strategic vision is also based on the development of the golf
              ecosystem through economic growth. A goal that undeniably involves
              the involvement of all golf operators.
              <br />
              <br />
              In addition, the Federation places particular emphasis on the
              preservation of water resources. The FRMG continues to support
              golf courses for the widespread irrigation of courses with treated
              wastewater.
              <br />
              <br />
              At the same time, the Federation encourages social integration by
              strengthening the formation of caddies, a real attraction for golf
              tourism. Measures to position golf as a true sustainable
              development niche.
            </p>
          </div>
        </div>
      </div>

      {/* <div className="flex flex-col ps-[7rem] mb-[8rem]">
        <h1 className="text-2xl  custom-font">Leave A Reply</h1>
        <p className="text-[#7c7c7c] text-[19px] font-[500] ">
          Vous devez <span className="text-[#45ac4d]">vous connecter</span> pour
          publier un commentaire.
        </p>
      </div> */}
    </>
  );
};
